<section class="form-metrics-group" *ngIf="group && visibleItems.length > 0">
  <button
    type="button"
    class="group-header btn btn-link text-left p-0 mb-1"
    (click)="toggleCollapse()"
    [attr.aria-expanded]="!isCollapsed">
    <i class="feather" [ngClass]="isCollapsed ? 'icon-chevron-right' : 'icon-chevron-down'"></i>
    <span class="group-title">{{ group.label }}</span>
  </button>

  <p class="group-description text-muted" *ngIf="group.description && !isCollapsed">
    {{ group.description }}
  </p>

  <div class="row form-metrics-items-row" *ngIf="!isCollapsed">
    <div
      class="col-12"
      [ngClass]="isFullWidthItem(i) ? 'col-md-12' : 'col-md-6'"
      *ngFor="let item of visibleItems; let i = index; trackBy: trackByItemId">
      <app-form-metrics-item-widget
        [item]="item"
        [highlightedEmployeeId]="highlightedEmployeeId"
        [categoryClickEnabled]="categoryClickEnabled"
        [highlightAnswers]="highlightAnswers"
        (openComments)="onOpenComments($event)"
        (categoryClick)="onCategoryClick($event)">
      </app-form-metrics-item-widget>
    </div>
  </div>
</section>
